import React from "react";
// libs
import styled, { css } from "styled-components";
// theme
import { typography, colors } from "src/theme";
// const
import devices from "src/constants/media";

export const Wrapper = styled.div`
  padding: 24px 24px 112px;

  @media ${devices.laptop} {
    display: grid;
    grid-template-columns: 1fr 400px;
    grid-column-gap: 46px;
  }
  @media ${devices.laptopL} {
    max-width: 1096px;
    margin: 0 auto;
  }
`;

export const AppointmentWidgetWrapperMobile = styled.div`
  margin-top: 48px;

  @media ${devices.laptop} {
    display: none;
  }
`;

export const AppointmentWidgetWrapperWeb = styled.div`
  display: none;

  @media ${devices.laptop} {
    display: block;
    width: 400px;
  }
`;

export const AppointmentWidgetStickyWrapperWeb = styled.div`
  position: sticky;
  top: 25px;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

export const BackButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  width: fit-content;
  cursor: pointer;
  margin-bottom: 40px;

  :hover {
    div {
      background-color: ${colors.mainVeryLight};
    }
  }

  @media ${devices.laptop} {
    margin-bottom: 56px;
  }
`;

export const BackButtonImageWrapper = styled.div`
  width: 44px;
  height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid ${colors.greyVeryLight};
  border-radius: 50%;
`;

export const BackButtonText = styled.p`
  margin: 0 12px;
  display: flex;
  align-items: center;
  font-family: ${typography.fontFamily};
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 28px;
  color: ${colors.grey};
`;

export const Subtitle = styled.p`
  font-family: ${typography.fontFamily};
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  color: ${colors.grey};
`;

export const LogoWrapper = styled.div`
  position: relative;
  width: 208px;
  height: 155px;

  .clinic_images {
    border-radius: 8px;
  }
`;

export const TopReviewsContainer = styled.div`
  // TEMPORARY MARGIN
  margin-top: 48px;

  @media (min-width: 600px) {
    display: grid;
    grid-template-columns: 1fr auto auto;
    grid-column-gap: 24px;
  }

  @media ${devices.laptopL} {
    display: grid;
    grid-template-columns: 1fr 170px 170px;
    grid-column-gap: 24px;
  }
`;

export const TopReviewsItemContainer = styled.div`
  margin: 18px 0;

  @media (min-width: 600px) {
    margin: 0;
  }
  @media ${devices.laptopL} {
    :nth-child(1) {
      margin-right: 96px;
    }
  }
`;

export const TopReviewsTitle = styled.div<{ isMarginBtm?: boolean }>`
  font-family: ${typography.fontFamily};
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  color: ${colors.grey};
  margin-bottom: ${({ isMarginBtm }) => (isMarginBtm ? 8 : 0)}px;
`;

export const TopReviewsTextBlue = styled.div`
  font-family: ${typography.fontFamily};
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 32px;
  color: ${colors.main};
`;

export const TopReviewsStarsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (min-width: 600px) {
    display: grid;
    grid-template-columns: 125px 150px;
    grid-column-gap: 16px;
    align-items: center;
    justify-content: unset;
  }
`;

export const SpeciesList = styled.ul`
  display: flex;
  align-items: center;
  white-space: nowrap;
  flex-wrap: wrap;
  margin: 22px 0 0 0;
  list-style: none;

  @media ${devices.laptop} {
    margin: 48px 0 0;
  }
`;

const offsetFromFirst = css`
  ::after {
    content: none;
  }
`;
const offsetFromSecond = css`
  ::after {
    content: "·";
    position: absolute;
    right: -10px;
    color: ${colors.grey};
  }
`;

export const SpeciesButton = styled.li<{ offsetFirst?: boolean }>`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 12px;
  border-radius: 4px;
  list-style: none;
  background-color: ${colors.mainLight};
  margin-right: 16px;

  font-family: ${typography.fontFamily};
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: ${colors.greyDark};

  ${({ offsetFirst }) => (offsetFirst ? offsetFromSecond : offsetFromFirst)};
`;

export const SectionTitle = styled.p`
  font-family: ${typography.fontFamily};
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 32px;
  color: ${colors.greyDark};
  margin-top: 48px;
`;

export const AboutText = styled.p`
  font-family: ${typography.fontFamily};
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  color: ${colors.grey};
  margin-top: 24px;
`;

export const ServicesContainer = styled.div<{ rows: number; columns: number }>`
  @media ${devices.tablet} {
    display: grid;
    grid-column-gap: 24px;
    grid-row-gap: 30px;

    grid-template-columns: repeat(${({ columns }) => columns}, 1fr);
    grid-template-rows: repeat(${({ rows }) => rows}, 1fr);
  }

  @media ${devices.laptop} {
    grid-template-columns: repeat(${({ columns }) => columns}, 1fr);
    grid-template-rows: repeat(${({ rows }) => rows}, 1fr);
  }

  @media ${devices.laptopL} {
    grid-template-columns: repeat(${({ columns }) => columns}, 1fr);
    grid-template-rows: repeat(${({ rows }) => rows}, 1fr);
  }
`;

export const ServiceWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 24px;
`;

export const ServiceImageWrapper = styled.div`
  flex-shrink: 0;
`;

export const ServiceText = styled.div`
  font-family: ${typography.fontFamily};
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: ${colors.grey};
  margin-left: 16px;
`;

export const MapContainer = styled.div`
  margin-top: 24px;
  height: 350px;
  max-width: 647px;

  .zoomControl {
    box-shadow: none !important;
    border: none !important;

    button {
      opacity: 1 !important;
      width: 32px !important;
      height: 32px !important;
      background-size: 32px 320px !important;
      border: 2px solid ${colors.greyVeryLight} !important;
      border-radius: 50% !important;
    }

    #zoomIn {
      background-position: -1px -2px !important;
      margin-bottom: 4px;
    }

    #zoomOut {
      background-position: -1px -33px !important;
    }
  }
`;

export const OpenTimesContainer = styled.div`
  margin-top: 24px;
  display: grid;
  grid-template-rows: repeat(4, 1fr);
  grid-row-gap: 20px;

  @media ${devices.tablet} {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(2, 1fr);
  }
`;

export const OpenTimesTitle = styled.div`
  font-family: ${typography.fontFamily};
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: ${colors.grey};
`;

export const OpenTimesText = styled.div`
  font-family: ${typography.fontFamily};
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  color: ${colors.grey};
`;

export const TeamContainer = styled.div<{ rows?: number }>`
  margin-top: 24px;
  display: grid;
  grid-template-rows: repeat(${({ rows }) => rows || 1}, 1fr);
  grid-row-gap: 20px;

  @media (min-width: 500px) {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(2, 1fr);
  }

  @media ${devices.laptopL} {
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: 1fr;
  }
`;

export const TeamUserWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media (min-width: 500px) {
    width: fit-content;
  }
`;

export const TeamAvatar = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: ${typography.fontFamily};
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  color: ${colors.white};

  img {
    border-radius: 50%;
  }
`;

export const TeamPosition = styled.div`
  font-family: ${typography.fontFamily};
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: ${colors.grey};
  margin-top: 4px;
`;

export const TeamName = styled.div`
  font-family: ${typography.fontFamily};
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  color: ${colors.grey};
  margin-top: 12px;
`;

export const BottomReviewsContainer = styled.div`
  margin-top: 24px;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(3, 1fr);

  @media ${devices.tablet} {
    display: flex;
    align-items: center;
  }
`;
export const BottomReviewsBox = styled.div`
  display: flex;
  height: fit-content;
  align-items: flex-end;
`;

export const BottomReviewsImageWrapper = styled.div``;

export const BottomReviewsTitle = styled.div`
  font-family: ${typography.fontFamily};
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 32px;
  color: ${colors.grey};
  margin: 0 8px 0 10px;

  @media ${devices.tablet} {
    margin: 0 0 0 12px;
  }
`;

export const BottomReviewsSubtitle = styled.div`
  font-family: ${typography.fontFamily};
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 32px;
  color: ${colors.grey};

  @media ${devices.tablet} {
    margin: 0 16px 0 8px;
  }
`;

export const BottomReviewsLink = styled.div`
  font-family: ${typography.fontFamily};
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: ${colors.grey};
  margin-top: 24px;
`;

export const BottomReviewsButtonsWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr;
  grid-column-gap: 8px;

  @media ${devices.tablet} {
    display: flex;
    justify-content: space-between;
    width: 250px;
  }

  button {
    width: 100%;
  }
`;

export const LinksContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 24px;

  @media ${devices.tablet} {
    flex-direction: row;
    flex-wrap: wrap;
  }

  /* margin-top: 24px;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(4, 1fr);
  grid-row-gap: 20px;

  @media ${devices.tablet} {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(2, 1fr);
    grid-column-gap: 24px;
    grid-row-gap: 20px;
  }

  @media ${devices.laptopL} {
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: 1fr;
    grid-column-gap: 24px;
  } */
`;

export const LinksItemWrapper = styled((props) => <a target="_blank" {...props} />)`
  background: ${colors.white};
  border: 2px solid ${colors.greyVeryLight};
  box-sizing: border-box;
  border-radius: 6px;
  display: flex;
  align-items: center;
  width: fit-content;
  text-decoration: none;
  cursor: pointer;
  margin-bottom: 24px;

  @media ${devices.tablet} {
    margin-bottom: 0;
    margin-right: 24px;
  }
`;

export const LinksItemImageWrapper = styled.div`
  flex-shrink: 0;
  margin-bottom: -4px;
`;

export const LinksItemText = styled.div`
  font-family: ${typography.fontFamily};
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: ${colors.greyDark};
  margin: 0 18px;
`;
export const TopReviewsBox = styled.div`
  @media ${devices.tablet} {
    display: flex;
    align-items: center;
  }
`;
export const TopReviewsItemBox = styled.div`
  display: flex;
  align-items: center;
  margin: 24px 0 28px;
`;
export const ButtonBox = styled.div`
  width: 100%;

  @media ${devices.tablet} {
    width: 150px;
  }
`;
export const TopReviewsText = styled.div`
  font-family: ${typography.fontFamily};
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  color: ${colors.grey};
  margin: 0 0 0 12px;

  @media ${devices.tablet} {
    margin: 0 16px 0 12px;
  }
`;
export const ReviewsContent = styled.div`
  /* width: 700px; */
  height: 155px;
  margin-top: 48px;
  margin-bottom: 48px;
  padding-left: 24px;

  @media ${devices.laptop} {
    width: 550px;
  }
  @media ${devices.laptopS} {
    width: 700px;
  }

  .slick-prev:before,
  .slick-next:before {
    color: grey;
  }
`;

export const styles = {
  back: {
    display: "flex",
    alignItems: "center",
    ":hover": {
      div: {
        backgroundColor: colors.mainVeryLight,
      },
    },
  },
};
